export const BUSINESS_TERMS_VERSION = "1.0";
export function BusinessTermsContent() {
  return <div className="prose prose-sm max-w-none text-foreground">
      <h2 className="text-xl font-display font-bold text-foreground mb-4">
    </h2>
      <p className="text-sm text-muted-foreground mb-6">Effective Date: January 2025</p>

      <p className="mb-4">
        By registering as a business user ("Business," "Provider," or "Merchant") on Wellness Connect 
        ("Platform," "We," "Us"), you confirm that you have read, understood, and agreed to these Terms and Conditions.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">1. Eligibility</h3>
      <p className="mb-2">You confirm that:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>You are legally registered to operate in your jurisdiction</li>
        <li>You have authority to bind the business you represent</li>
        <li>All information submitted is accurate and up to date</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">2. Platform Role & Disclaimer</h3>
      <p className="mb-2">Wellness Connect:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Acts only as a digital platform connecting customers and wellness providers</li>
        <li>Does not provide medical, therapeutic, or professional advice</li>
        <li>Is not liable for the quality, legality, or outcomes of services provided by businesses</li>
      </ul>
      <p className="mb-4">All services are rendered solely by the registered business.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">3. Business Responsibilities</h3>
      <p className="mb-2">You agree to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Comply with all applicable laws and regulations in your jurisdiction</li>
        <li>Secure necessary licenses, permits, and certifications</li>
        <li>Ensure services offered are lawful, ethical, and accurately described</li>
        <li>Handle customer interactions professionally and confidentially</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">4. Data Privacy & Confidentiality</h3>
      <p className="mb-2">You acknowledge that:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>You may receive personal or sensitive personal information of customers</li>
        <li>You shall process such data strictly for service fulfillment purposes</li>
        <li>You shall comply with applicable data protection laws</li>
        <li>You shall not misuse, sell, or disclose customer data without lawful basis</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">5. Platform Data Use</h3>
      <p className="mb-2">By registering, you authorize Wellness Connect to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Collect and process business and representative information</li>
        <li>Use data for account management, verification, analytics, and platform improvement</li>
        <li>Share limited data with customers for service fulfillment</li>
      </ul>
      <p className="mb-4">All processing follows our Privacy Policy.</p>

      <h3 className="text-lg font-semibold mt-6 mb-3">6. Payments & Transactions</h3>
      <p className="mb-2">If payments are enabled:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Wellness Connect may facilitate payment processing</li>
        <li>Transaction fees or commissions may apply</li>
        <li>Disputes relating to services are primarily between Business and Customer</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">7. Suspension & Termination</h3>
      <p className="mb-2">We reserve the right to suspend or terminate accounts for:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>False or misleading information</li>
        <li>Legal or regulatory violations</li>
        <li>Customer abuse or repeated complaints</li>
        <li>Breach of these Terms</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">8. Limitation of Liability</h3>
      <p className="mb-4">
        To the maximum extent allowed by law, Wellness Connect shall not be liable for:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Service outcomes</li>
        <li>Business losses</li>
        <li>Indirect or consequential damages</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-3">9. Governing Law</h3>
      <p className="mb-4">
        These Terms are governed by applicable law in your jurisdiction.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-3">10. Acceptance</h3>
      <p className="mb-4">
        By clicking "I Agree", you confirm acceptance of these Terms and the Privacy Policy.
      </p>

      <div className="mt-8 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <h4 className="font-semibold text-foreground mb-2">Data Privacy Consent</h4>
        <p className="text-sm">
          "I consent to the collection, processing, storage, and sharing of my personal information 
          in accordance with applicable data protection laws and the 
          Wellness Connect Privacy Policy."
        </p>
      </div>
    </div>;
}
